import React from 'react';

import { Body, Heading } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { getDetailedBagItemCount } from '@/modules/bag/helpers';
import { useBagDetailed } from '@/modules/bag/useBagDetailed';

function QuickAccessBagHeader() {
  const {
    query: { data, isLoading, isFetching },
  } = useBagDetailed({ enabled: true, includeOffers: true });

  const t = useTranslations('bag');

  const itemCount = data ? getDetailedBagItemCount(data) : 0;

  function renderStatus() {
    switch (true) {
      case isLoading === true:
      case isFetching === true:
        return (
          <Body variant="sm-regular">{t('Bag.QuickAccess.HeaderLoading')}</Body>
        );
      case itemCount > 0:
        return (
          <Body variant="sm-regular">
            {t('Bag.QuickAccess.HeaderItemsCount', { count: itemCount })}
          </Body>
        );
      default:
        return null;
    }
  }

  return (
    <div className={styles.wrapper}>
      <Heading variant="lg" className={styles.heading}>
        {t('Bag.QuickAccess.HeaderTitle')}
      </Heading>
      {renderStatus()}
    </div>
  );
}

export { QuickAccessBagHeader };
